import React, { useEffect, useState } from 'react';
import './App.scss';
import { getCookie } from './helpers/CookieHelper';
import { CartItem } from './components/Cart/cart-interface';
import HeaderNavbar from './components/Navbar/Navbar';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer/Footer';
import User from './components/User/User';
import Cart from './components/Cart/Cart';
import Verify from './components/Verify/Verify';
import EnvComponent from './components/EnvComponent/EnvComponent';
import Empty from './components/Empty/Empty';
import ThankYou from './components/ThankYou/ThankYou';
import LeftMenuContextProvider from './contexts/login.context';
import useLoader from './contexts/LoaderContext';
import './i18n/config';
import LocalizationProvider from './contexts/LocalizationContext';
import GeoRedirect from './components/GeoRedirect/GeoRedirect';
import TestPDP from './components/TestPDP/TestPDP';

// Layout component that includes HeaderNavbar and Footer
const AppLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <HeaderNavbar />
      {children}
      <Footer />
    </>
  );
};

function App() {
  const isDownload: boolean = true;
  const isVerify: boolean = false;
  const isThanks: boolean = false;
  // Initialize state variables for the cookie name and value with default values
  const [cookieName, setCookieName] = useState('nvHeadless');
  const [cookieValue, setCookieValue] = useState<CartItem[]>([]);
  const { isBodyLoading } = useLoader();
  useEffect(() => {
    // Console lock starts
    if ((window?.location?.host.split(".")[0] === "store") && !(window.location.host.indexOf("localhost") > -1)) {
      window.console.log = function () { };
    }
    // Console lock ends
    // Get the cookie value by name and update the state, setting the default values if not found
    const myCookieValue = getCookie('nvHeadless');
    if (myCookieValue) {
      setCookieName(cookieName); // Set the cookie name if found
      setCookieValue(cookieValue); // Set the cookie value if found
    }
  }, [cookieName, cookieValue]);
  const initialValidationErrors: Record<string, string> = {};
  return (
    <div className={isBodyLoading ? "loading App" : "App"}>
      <BrowserRouter>
        <LocalizationProvider>
          <LeftMenuContextProvider>
            <Routes>
              <Route path="*" element={<AppLayout><EnvComponent /></AppLayout>}></Route>
              <Route path=":locale/buy" element={<GeoRedirect />}></Route>
              <Route path=":locale/pdp" element={<AppLayout><TestPDP /></AppLayout>}></Route>
              <Route path=":locale/software/cart" element={<AppLayout><EnvComponent /></AppLayout>}></Route>
              <Route path=":locale/software/cart/empty" element={<AppLayout><Empty /></AppLayout>}></Route>
              <Route path=":locale/software/cart/view" element={<AppLayout><Cart onCartChange={(e) => { }} validationErrors={initialValidationErrors} onPromoChange={(e) => { }} onPromoSubmit={(e) => { }} onPromoDelete={(e) => { }} isDownload={isDownload} isVerify={isVerify} isThanks={isThanks} cartData={''} promoCodeError={false} /></AppLayout>}></Route>
              <Route path=":locale/software/cart/user" element={<AppLayout><User /></AppLayout>}></Route>
              <Route path=":locale/software/cart/user/:userType" element={<AppLayout><User /></AppLayout>}></Route>
              <Route path=':locale/software/cart/verify' element={<AppLayout><Verify /></AppLayout>}></Route>
              <Route path=":locale/software/cart/thankyou" element={<AppLayout><ThankYou /></AppLayout>}></Route>
            </Routes>
          </LeftMenuContextProvider>
        </LocalizationProvider>
      </BrowserRouter>
      <div className="overlay"><div className="center-ovelay"><div className="swg-spinner-wrapper"><div className="swg-spinner"></div></div></div></div>
    </div >
  );
}

export default App;
